"use client";

import { useQuery } from "@tanstack/react-query";
import { useAccessToken, useTenantData } from "@/hooks/shared";
import { fetchWidgetDataBatched } from "@/lib/dashboard/widgets-client";
import { SCHEDULED_DROP_WIDGET_REFRESH_MS } from "@/lib/dashboard/scheduled-drop-widget-constants";
import { parseScheduledDropEnrollmentsFromWidgetData } from "@/lib/dashboard/scheduled-drop-enrollments-widget";
import { DashboardWidgetId } from "@/lib/types/dashboard-widgets";
import { QueryKeys } from "@/lib/types";

export function useScheduledDropEnrollmentsWidget(enabled = true) {
  const accessToken = useAccessToken();
  const { tenantId } = useTenantData();

  return useQuery({
    queryKey: [
      QueryKeys.WidgetData,
      tenantId,
      DashboardWidgetId.ScheduledDropEnrollments,
    ],
    enabled:
      enabled && !!accessToken && tenantId != null && tenantId > 0,
    queryFn: async () => {
      const token = accessToken;
      const tid = tenantId;
      if (!token || tid == null) {
        throw new Error("Missing session or tenant for drop requests widget");
      }
      const items = await fetchWidgetDataBatched(token, tid, [
        DashboardWidgetId.ScheduledDropEnrollments,
      ]);
      return parseScheduledDropEnrollmentsFromWidgetData(items);
    },
    staleTime: SCHEDULED_DROP_WIDGET_REFRESH_MS,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
}
